import React, { createContext, useCallback, useRef, useState } from "react";
import { Document, Image, Page, pdf } from "@react-pdf/renderer";
import html2canvas from "html2canvas";
import { LoanDetails } from "../views/comparison_views/molecules/LoanDetails";
import { PdfContainer } from "../views/comparison_views/molecules/ui-utils";

async function renderPdf(canvasDataUrl) {
  return await pdf(
    // style props are required for correct functioning of the PDF creation
    <Document>
      <Page size="letter" style={{ padding: "0.25in" }}>
        <Image
          src={canvasDataUrl}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            objectPosition: "top",
          }}
        />
      </Page>
    </Document>
  ).toBlob();
}

async function renderDivToPdfBlob(divElement) {
  divElement.style.display = "block";

  const canvas = await html2canvas(divElement);

  divElement.style.display = "none";

  const canvasDataUrl = canvas.toDataURL("image/png");
  const pdfBlob = await renderPdf(canvasDataUrl);

  return pdfBlob;
}

export const LoanPdfContext = createContext({
  renderLoanPdf: (loanDetails) => {},
});

export function LoanPdfProvider({ children }) {
  const pdfContainerRef = useRef(null);
  const isRenderingRef = useRef(false);
  const [loanDetails, setLoanDetails] = useState(undefined);

  const renderLoanPdf = useCallback(
    (loanDetails) => {
      return new Promise((resolve, reject) => {
        if (!pdfContainerRef.current) {
          reject("pdfContainerRef is not defined");
          return;
        }

        if (isRenderingRef.current) {
          reject("Already rendering");
          return;
        }

        isRenderingRef.current = true;
        setLoanDetails(loanDetails);

        setTimeout(() => {
          renderDivToPdfBlob(pdfContainerRef.current)
            .then((blob) => {
              resolve(blob);
              setLoanDetails(undefined);
              isRenderingRef.current = false;
            })
            .catch(reject);
        }, 100);
      });
    },
    [pdfContainerRef, isRenderingRef]
  );

  return (
    <>
      <PdfContainer ref={pdfContainerRef}>
        {loanDetails && (
          <LoanDetails {...loanDetails} isPrinting={true} onEditClick={null} />
        )}
      </PdfContainer>

      <LoanPdfContext.Provider value={{ renderLoanPdf }}>
        {children}
      </LoanPdfContext.Provider>
    </>
  );
}
